import * as api from '../api/index'
import { AUTH, CREATE_PROFILE } from './constants'


export const signin =(formData, openSnackbar, setLoading) => async(dispatch) => {

    try {
        //login the user
        const { data } = await api.signIn(formData)         

        dispatch({ type: AUTH, data})
        // setLoading(false)
        openSnackbar("Signin successfull")
        // history.push('/dashboard')
        window.location.href="/home"

    } catch (error) {
        // console.log(error?.response?.data?.message)
        openSnackbar("Signin fail. Please check credential and try again")
        console.log(error)
        setLoading(false)
    }
}

export const signup =(formData, openSnackbar, setLoading) => async(dispatch) => {

    try {
        //Sign up the user
        console.log("formData",formData);
        const { data } = await api.signUp(formData)
        dispatch({ type: AUTH, data})
        window.location.href="/home"
        openSnackbar("Sign up successfull")

    } catch (error) {
        console.log(error)
        openSnackbar("Sign up fail")
        openSnackbar(error?.response?.data?.message)
        setLoading(false)
    }
}



export const forgot =(formData) => async(dispatch) => {
    try {
        await api.forgot(formData)
    } catch (error) {
        console.log(error)
    }
}


export const reset =(formData, history) => async(dispatch) => {

    try {
        await api.reset(formData)
        history.push('/home')

    } catch (error) {
        alert(error)
    }
}
